import { render, staticRenderFns } from "./psuServicepayIndex.vue?vue&type=template&id=6e97ea20&"
import script from "./psuServicepayIndex.vue?vue&type=script&lang=js&"
export * from "./psuServicepayIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports